
export const getWindowParams = (width = 300, height = 300) => {

    return `width=${width}, height=${height}, left=${(window.innerWidth / 2) - (width)}, top=${(window.innerHeight / 2) - (height)}`;
}
export const getWindowParams = (width = 300, height = 300) => {

    return `width=${width}, height=${height}, left=${(window.innerWidth / 2) - (width)}, top=${(window.innerHeight / 2) - (height)}`;
}